export default __webpack_public_path__ + "static/media/room-mel-main.e746ead0.webp";